export const getIsGiideLimitedReached = (user, numGiidesCreatedOnAccount) => {
  if (!user) return false;

  if (!user.plan) return false;

  const accountHasGiideLimit =
    user?.plan?.features?.giideMaxNumberOfGiides?.hasLimit;

  if (!accountHasGiideLimit) return false;

  const accountGiideLimit =
    user?.plan?.features?.giideMaxNumberOfGiides?.limitAmount || 0;

  return numGiidesCreatedOnAccount >= accountGiideLimit;
};

export const getTotalGiidesCreated = user => {
  if (!user || !user.plan) return 0;

  const plan = user.plan;

  if (
    // If the user is "legacy_active"
    plan.accountStatus === 'legacy_active' &&
    plan.features.giideMaxNumberOfGiides.hasLimit === true &&
    plan.giidesCreatedListFreePlan
  ) {
    return plan.giidesCreatedListFreePlan.length;
  } else {
    // For all new users since free trial launch
    return plan?.totalGiidesCreated || 0;
  }
};
